<div class="login-container d-flex justify-content-center align-items-center">
  <div class="login-box">
    <div class="login-body">
      <div class="p-2 mb-4 border-bottom">
        <img
          src="../../../../assets/img/logos/voltsystems150.png"
          data-cy="volt-logo"
          class="login-logo"
          alt="Volt Systems Logo"
          style="width: 90%"
        />
      </div>

      <div>
        <p class="fw-semibold mb-2 text-muted">Access Denied</p>

        <div class="mb-4 text-muted">
          You do not currently have access to Scintilla In-Store. Please submit a request for <b>
          “Scintilla In-Store HO
          User” </b> AD Group.
        </div>
      </div>

      <button type="button" class="btn btn-primary w-100 rounded-0 custom-login-button" (click)="confirmSignOut()">
        Back to Login
      </button>
    </div>
  </div>
</div>
